var $50d639be1d52f61f$exports = {};
$50d639be1d52f61f$exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`
};


export {$50d639be1d52f61f$exports as default};
//# sourceMappingURL=bg-BG.module.js.map
